import classNames from 'classnames'
import { t } from 'i18next'

import { Popover } from '@lounge-fe/ui-kit/src/components/Popover'
import { Icon } from '@lounge-fe/ui-kit/src/components/Icon'
import { Button } from '@lounge-fe/ui-kit/src/components/Button'
import { Portal } from '@lounge-fe/ui-kit/src/components/Portal'
import { Text } from '@lounge-fe/ui-kit/src/components/Text'
import { CloseIconButton } from '@lounge-fe/ui-kit/src/components/CloseIconButton'
import { Transition } from '@lounge-fe/ui-kit/src/components/Transition'

import { Form } from '../Form'
import { FilterByProps } from '../types'

export const FilterByMobile = ({
  name,
  sections,
}: FilterByProps): JSX.Element => (
  <Popover>
    {({ isOpen, onClose }) => (
      <>
        <Popover.Trigger>
          <Button
            className="w-full h-full rounded-[0] normal-case typography typography--body-sm"
            variant="ghost"
            endIcon={
              <Icon.ChevronDown
                className={classNames('w-2 transition', isOpen && 'rotate-180')}
              />
            }
          >
            {isOpen ? t('action.hide_filters') : t('action.show_filters')}
          </Button>
        </Popover.Trigger>

        <Portal>
          <Transition.Slide
            direction="bottom"
            className="fixed inset-0 bg-white z-50"
          >
            <Popover.Content className="flex flex-col h-full max-h-full relative">
              <div
                className="
                  py-4 px-6 sticky top-0 bg-white z-10 
                  flex justify-between items-center 
                  border-b border-primary-default"
              >
                <Text variant="title-six" className="text-md">
                  {t('action.filter_by')}
                </Text>
                <CloseIconButton onClick={onClose} aria-label="Close" />
              </div>
              <Form
                className="h-full max-h-ful flex-1 px-6 pt-4 pb-[100px]"
                name={name}
                sections={sections}
                showActions
                onClose={onClose}
              />
            </Popover.Content>
          </Transition.Slide>
        </Portal>
      </>
    )}
  </Popover>
)
